<template>
  <div class="theLogin">
    <img src="eSano_cms.png">
    <div class="languageSelection" style="margin: 20px auto;">
      <div style="position: relative;">
        <i class="fas fa-globe globeIcon"></i>
        <select
          id="inputLanguage"
          class="languageSelectStyling"
          v-model="selectedAppLanguage"
          @change="changeAppLanguage"
        >
          <option id="inputLanguagede" value="de">
            Deutsch
          </option>
          <option id="inputLanguageen" value="en">
            English
          </option>
        </select>
      </div>
    </div>

    <form class="loginForm" @submit.prevent="loginFunction(email, password)">
      <input
        type="email"
        v-model="email"
        id="inputMailLogin"
        :placeholder="$t('generalTranslation.email') + ' *'"
        formControlName="email"
        autocomplete="username"
        required
      >
      <div v-if="email === ''" id="errorMailEmpty" class="loginErrorMessage">
        {{ $t("loginTranslation.errorEnterEmail") }}
      </div>
      <div v-else-if="isInvalidEmail(email)" id="errorMailInvalid" class="loginErrorMessage">
        {{ $t("loginTranslation.errorEnterValidEmail") }}
      </div>
      <br>

      <input
        :type="showPassword ? 'text' : 'password'"
        v-model="password"
        id="inputPWLogin"
        :placeholder="$t('loginTranslation.password') + ' *'"
        formControlName="password"
        autocomplete="password"
        required
      >
      <a class="suffix-icon" @click="showPassword = !showPassword">
        <i class="fas" :class="[showPassword ? 'fa-eye' : 'fa-eye-slash']"></i>
      </a>
      <div v-if="password === ''" id="errorPWEmpty" class="loginErrorMessage">
        {{ $t("loginTranslation.errorEnterPassword") }}
      </div>
      <br>

      <router-link to="/resetpassword" id="resetPWLink" class="resetPWLink">
        {{ $t("loginTranslation.forgotPassword") }}
      </router-link>
      <br>

      <button type="submit" id="loginButton" :disabled="password === '' || isInvalidEmail(email)">
        {{ $t("loginTranslation.login") }}
      </button>
    </form>

    <footer>
      <router-link to="/imprint" id="imprintLink">
        {{ $t("generalTranslation.imprint") }}
      </router-link>
      |
      <router-link to="/privacy" id="privacyLink">
        {{ $t("generalTranslation.privacy") }}
      </router-link>
    </footer>

    <BaseNotification></BaseNotification>
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters, mapMutations } from "vuex";
import httpHelper from "../mixins/httpHelper";
import utils from "../mixins/utils";
import router from "../router";
import BaseNotification from "./BaseNotification.vue";

export default {
  name: "TheLogin",

  components: {
    BaseNotification,
  },

  mixins: [httpHelper, utils],

  data: function() {
    return {
      email: "",
      password: "",
      showPassword: false,
      selectableLanguages: ["de", "en"],
      selectedLanguage: "en",
    };
  },

  computed: {
    ...mapGetters([
      "getAppLanguage",
      "getNotificationText",
      "getRoles",
      "getToken",
    ]),
  },

  created() {
    this.selectedAppLanguage = this.getAppLanguage === "de" ? "de" : "en";
    this.changeAppLanguage();
  },

  watch: {
    getRoles(newVal) {
      if (newVal != "" && newVal != -1) {
        if (newVal.includes("admin") || newVal.includes("editor")) {
          router.push({ name: "home"});
        } else {
          router.push({ name: "logout"});
          this.SET_NOTIFICATIONTEXT({
            type: "error",
            text: Vue.i18n.translate("httpHelperTranslation.errorCode2"),
          });
        }
      }
    },

    getNotificationText(newVal) {
      if (newVal != "" && newVal.type === "error") {
        localStorage.clear();
      }
    },

    getToken(newVal) {
      if (newVal === "") {
        localStorage.clear();
      }
    },
  },

  methods: {
    ...mapMutations([
      "CHANGE_TOKEN",
      "SET_APPLANGUAGE",
      "SET_NOTIFICATIONTEXT",
    ]),

    loginFunction: function(email, password) {
      this.SET_NOTIFICATIONTEXT({
        type: "load",
        text: Vue.i18n.translate("loginTranslation.loginLoad"),
      });
      this.loginRequest(email, password)
        .then((response) => {
          this.CHANGE_TOKEN(response.data.data.attributes.token);
          this.SET_NOTIFICATIONTEXT("");
          this.requestMyRoles();
        })
        .catch((error) => {
          this.handleErrorsNotLoggedIn(error, "");
        });
    },

    changeAppLanguage: function() {
      Vue.i18n.set(this.selectedAppLanguage);
      this.SET_APPLANGUAGE(this.selectedAppLanguage);
    },
  },
}
</script>
